var _defs, _polygon, _polygon2, _polygon3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSmallBlue(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "OBJECTS",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 368.5 528",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #033489;\n      }\n    "))), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "146.48 193.43 146.48 425.22 114.03 425.22 114.03 252.99 34.1 299.9 34.1 425.22 1.64 425.22 1.64 278.44 34.1 259.39 114.03 212.49 146.48 193.43"
  })), _polygon2 || (_polygon2 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "296.99 107.3 296.99 325.69 264.53 306.88 264.53 124.59 146.48 56.18 146.48 184.96 114.03 204.01 114.03 1.25 146.48 20.06 264.53 88.49 296.99 107.3"
  })), _polygon3 || (_polygon3 = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "367.29 374.91 367.29 528 334.84 528 334.84 391.56 296.99 369.63 264.53 350.82 216.92 323.22 216.92 528 184.48 528 184.48 268.95 216.92 287.75 264.53 315.35 296.99 334.16 334.84 356.1 367.29 374.91"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSmallBlue);
export default __webpack_public_path__ + "static/media/smallBlue.6288a3956f2eb1e649786c9ede32ce24.svg";
export { ForwardRef as ReactComponent };